import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import VideoInfo from "./components/VideoInfo";
import KitOficial from "./components/KitOficial";
import Gallery from "./components/Gallery";
import Partners from "./components/Partners";
import Countdown from "./components/Countdown";
import Registration from "./components/Registration";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <VideoInfo />
        <KitOficial />
        <Gallery />
        <Partners />
        <Countdown />
        <Registration />
      </main>
      <Footer />
    </div>
  );
}